import { ChartTypeConfig } from './ChartTypeConfig';
import { SeriesType } from '../utils/SeriesType';
import { BasicChart, SeriesOption } from '../utils/models';
import { ChartConfig } from './ChartConfig';

export class BarChartConfig extends ChartConfig implements ChartTypeConfig {
  getConfig(categories: string[], data: SeriesOption[], colors: string[]): Partial<BasicChart> {

    const series = data.map((seriesData, index) => ({
      ...seriesData,
      name: seriesData.name,
      type: SeriesType.Bar,
      label: {
        show: true,
        position: seriesData.stack ? 'inside' : 'right',
        formatter: seriesData.label?.formatter ?? ((params) => `${parseInt(params.value)?.toFixed(1)}%`)
      },
      itemStyle: {
        color: seriesData.itemStyle?.color ?? colors[index % colors.length]
      },
      data: (seriesData.data ?? []).map((point: any) => {
        if (point.value)
          return {
            ...point,
            itemStyle: {
              ...point.itemStyle,
              borderRadius: seriesData.stack == 'total' ? '' : point.value > 0 ? [0, 8, 8, 0] : [8, 0, 0, 8],
            }
          }

        return {
          value: point,
          itemStyle: {
            borderRadius: seriesData.stack == 'total' ? '' : (point > 0) ? [0, 8, 8, 0] : [8, 0, 0, 8],
          }
        }
      }),
      barMaxWidth: 100
    })) as SeriesOption[];


    return {
      xAxis: {
        type: 'value',
        data: undefined,
        max: undefined,
        axisLine: { show: true },
        splitLine: { show: true },
        axisLabel: { formatter: (value) => value + '%' }
      },
      yAxis: {
        type: 'category',
        data: categories,
        max: undefined,
        axisLabel: { formatter: null }
      },
      series,

    };
  }
}
